import React from 'react';
import styles from'./GenderSelector.module.scss';
import { $t } from '../../../helpers/translator';

class GenderSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: props.gender ? props.gender : 0
        };
    }

    componentDidMount() {
        // console.log('gender state', this.state)
        // console.log('gender props', this.props)

        if (typeof(this.state.selected) === "string" && Number.isInteger(parseInt(this.state.selected))) {
            this.setState({selected: parseInt(this.state.selected)})
        }
    }

    select(value) {
        // console.log('>>>>>>>>>> gender',this.state)
        this.setState({ selected: value }, () => {
            this.props.onValueChange({
                value: value
            });
            // console.log(this.state)
        });
    }

    render() {
        let selected = this.state.selected;
        // console.log('selected', selected)

        return (
            <div className={`${styles['container']}` }>
                <div onClick={() => this.select(1)}
                     className={`${styles['option']} ${styles[(selected === 1 ? 'selected' : '')]}` }>
                    {$t('global.general.male')}
                </div>

                <div onClick={() => this.select(2)}
                     className={`${styles['option']} ${styles[(selected === 2 ? 'selected' : '')]}` }>
                    {$t('global.general.female')}
                </div>

                <div onClick={() => this.select(0)}
                     className={`${styles['option']} ${styles[(selected === 0 ? 'selected' : '')]}` }>
                    {$t('global.general.other')}
                </div>
            </div>
        );
    }
}

export default GenderSelector;
